import { Flex, INNER_MAX_WIDTH, READABLE_LINE_MAX_WIDTH, Rte, Text } from '@capioweb/ui-components/src'
import { QBankImage } from '../../@types/CapioWeb/core'
import Property, { BooleanProperty, StringProperty } from '../../@types/EpiFoundationSpa/Property'
import { LayoutsDesktop, LayoutsMobile } from './Layouts'
import { BlockCommonLayout } from '../../utils/layout'


export type ImageStackContentAreaProperty = Property<ImageStackBlockItemProps[]>
interface ImageStackBlockProps {
    heading: StringProperty
    preamble?: StringProperty
    items: ImageStackContentAreaProperty
    leftAligned: BooleanProperty
    layout: { value: StringProperty }
}
export interface ImageStackBlockItemProps {
    backgroundColor: StringProperty
    icon: StringProperty
    iconText: StringProperty
    image: QBankImage
    leftAligned: BooleanProperty
    displayText: StringProperty
}
const ImageStackBlock: React.FC<ImageStackBlockProps> = ({ items, layout, leftAligned, heading, preamble }) => {

    return (
        <BlockCommonLayout heading={heading}>


            <Flex
                w={1}
                flexDirection="column"
                maxw={INNER_MAX_WIDTH}
                style={{ margin: "0 auto" }}
            >
                {preamble?.value && (
                    <Flex maxw={READABLE_LINE_MAX_WIDTH} mx='auto' w={1} justifyContent='center'>
                        <Text as="div" variant="paragraph-16" textAlign="center">
                            <Rte>
                                <div
                                    dangerouslySetInnerHTML={{ __html: preamble.value }}
                                />
                            </Rte>
                        </Text>
                    </Flex>
                )}
                <Flex
                    maxw={READABLE_LINE_MAX_WIDTH}
                    rowGap={3}
                    columnGap={3}
                    flexWrap="wrap"
                    mx={leftAligned?.value ? 0 : "auto"}
                    w={1}
                    display={{ _: "none", m: "flex" }}
                >
                    <LayoutsDesktop items={items} value={layout.value.toString()} />
                </Flex>
                <Flex
                    rowGap={2}
                    columnGap={2}
                    flexWrap="wrap"
                    mx={leftAligned?.value ? 0 : "auto"}
                    w={1}
                    display={{ _: "flex", m: "none" }}
                >
                    <LayoutsMobile items={items} value={layout.value.toString()} />
                </Flex>
            </Flex>
        </BlockCommonLayout>
    )
}
export { ImageStackBlock }